export enum GroupAppResource {
    CHANNEL = 'channel',
    EVENT = 'event',
    PDF = 'pdf',
    VIDEO = 'video',
    AUDIO = 'audio',
    COURSE = 'course',
    EMBED = 'embed',
    QUIZ = 'quiz',
    ASSIGNMENT = 'assignment',
    GROUP_PLAN = "group_plan",
    ARTICLE = "article"
}